export enum IProssionalRoleTypeEnum {
  regular = 'regular',
  administrator = 'administrator',
}
